import { render, staticRenderFns } from "./FeaturedGoodList.vue?vue&type=template&id=680c3b29&scoped=true&"
import script from "./FeaturedGoodList.vue?vue&type=script&lang=js&"
export * from "./FeaturedGoodList.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedGoodList.vue?vue&type=style&index=0&id=680c3b29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c3b29",
  null
  
)

export default component.exports